import React, { useCallback } from "react";
import {
  Autocomplete,
  EraserIcon,
  FormField,
  IconButton,
  Pane,
  TextInput,
} from "evergreen-ui";

const AutocompleteFormField = ({
  disabled,
  items,
  itemToString,
  onChange,
  placeholder,
  value,
  ...props
}) => {
  const handleEditClick = useCallback(() => {
    onChange();
  }, [onChange]);

  if (value) {
    return (
      <FormField {...props}>
        <Pane display="flex">
          <TextInput
            disabled
            value={itemToString ? itemToString(value) : value}
            flex="1 1 auto"
            width="100%"
          />
          {!disabled ? (
            <IconButton
              appearance="minimal"
              aria-label="clear selection"
              disabled={disabled}
              flex="0 0 auto"
              icon={EraserIcon}
              onClick={handleEditClick}
            />
          ) : null}
        </Pane>
      </FormField>
    );
  }

  return (
    <FormField {...props}>
      <Autocomplete
        {...props}
        items={items}
        itemToString={itemToString}
        onChange={onChange}
      >
        {({ getInputProps, getRef, inputValue, openMenu }) => (
          <TextInput
            disabled={disabled}
            placeholder={placeholder}
            value={inputValue}
            ref={getRef}
            width="100%"
            {...getInputProps({ onFocus: () => openMenu() })}
          />
        )}
      </Autocomplete>
    </FormField>
  );
};

export default AutocompleteFormField;
